import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_announce_sdn.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-35961761")

_pushScopeId("data-v-35961761")
const _hoisted_1 = {
  "aria-live": "polite",
  "aria-atomic": "true"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  width: "24",
  height: "24",
  class: "flex-shrink-0",
  alt: "",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_3 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.side !== 'none')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          "data-testid": "booking-sdn-banner",
          "data-sdn-side": _ctx.state.side,
          class: [{ 'booking-sdn-banner-v3': _ctx.variant === 'v3' }, "booking-sdn-banner flex items-center font-montserrat font-medium"],
          role: "status"
        }, [
          _hoisted_2,
          _createVNode("span", null, [
            (_ctx.contextLabel)
              ? (_openBlock(), _createBlock("strong", _hoisted_3, _toDisplayString(_ctx.contextLabel) + ": ", 1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.message), 1)
          ])
        ], 10, ["data-sdn-side"]))
      : _createCommentVNode("", true)
  ]))
})